import { UrlApi } from "../../services/apirest";

async function leerJson(response) {
  try {
    return await response.json();
  } catch {
    return {};
  }
}

export async function listarCorreosFallidos() {
  const response = await fetch(`${UrlApi}/correos-fallidos`);
  const body = await leerJson(response);
  if (!response.ok || body.ok === false) {
    const error = new Error(body.msg || body.message || "No se pudo cargar el listado.");
    error.status = response.status;
    error.body = body;
    throw error;
  }
  return Array.isArray(body.data) ? body.data : [];
}

export async function corregirCorreoFallido(idLog, email) {
  const response = await fetch(`${UrlApi}/correos-fallidos/${idLog}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  });
  const body = await leerJson(response);
  if (!response.ok || body.ok === false) {
    const error = new Error(
      body.msg || body.message || mensajePorEstado(response.status)
    );
    error.status = response.status;
    error.body = body;
    throw error;
  }
  return body;
}

function mensajePorEstado(status) {
  if (status === 400) return "El mail es inválido o es igual al que falló.";
  if (status === 409) return "Ese correo ya no está en la ficha. El texto actual es otro.";
  if (status === 404) return "Ese intento ya no está para corregir.";
  return "No se pudo guardar el mail.";
}
